// RiwayatTab.js — Tab Riwayat Pengajuan
import React, { useState, useEffect } from 'react'
import { STAGES, STATUS_PENGAJUAN, STATUS_PENETAPAN, statusTagClass, fmtDate } from './khasConstants'
import { penetapanApi, pengajuanApi } from './khasApi'
import KhasSearchInput from './KhasSearchInput'

/* ── RiwayatCard ─────────────────────────────────────────── */
function RiwayatCard({ sub, session, onGoTab, penetapanList }) {
  const [expanded,  setExpanded]  = useState(false)
  const [riwayat,   setRiwayat]   = useState([])
  const [loadingRw, setLoadingRw] = useState(false)

  const isMine      = sub.submitted_by === session.id
  const isDitolak   = sub.status === STATUS_PENGAJUAN.DITOLAK
  const isDisetujui = sub.status === STATUS_PENGAJUAN.DISETUJUI
  const penetapan   = penetapanList.find(p => p.pengajuan_id === sub.id)
  const isPtDitolak = penetapan?.status === STATUS_PENETAPAN.DITOLAK

  const stagesDone = (() => {
    if (penetapan?.status === STATUS_PENETAPAN.SELESAI)   return 5
    if (penetapan?.status === STATUS_PENETAPAN.DISETUJUI) return 4
    if (penetapan?.status === STATUS_PENETAPAN.PROSES)    return 3
    if (sub.status === STATUS_PENGAJUAN.DISETUJUI)         return 2
    return 1
  })()

  const pct = stagesDone >= 5 ? 100 : Math.round((stagesDone / (STAGES.length - 1)) * 100)
  const currentStageLabel = stagesDone < 5 ? STAGES[stagesDone]?.b : STAGES[4]?.b

  const handleExpand = async () => {
    if (!expanded && riwayat.length === 0) {
      setLoadingRw(true)
      try {
        const data = await pengajuanApi.getById(sub.id)
        setRiwayat(data.riwayat || [])
      } catch (err) { console.error(err) }
      setLoadingRw(false)
    }
    setExpanded(p => !p)
  }

  const riwayatByStage = {}
  riwayat.forEach(r => { riwayatByStage[r.tahap] = r })

  return (
    <div className="khas-card" style={{ marginBottom:12 }}>

      {/* Header */}
      <div className="khas-riwayat-top">
        <div className="khas-riwayat-meta">
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
            <span className={'khas-tag '+statusTagClass(sub.status)}>{sub.status}</span>
            {penetapan && <span className={'khas-tag '+statusTagClass(penetapan.status)}>{penetapan.status}</span>}
            {!isMine && <span className="khas-tag baru" style={{ fontSize:10 }}>Oleh: {sub.submitted_by_nama||'—'}</span>}
          </div>
          <h3 style={{ fontSize:16, margin:'0 0 2px' }}>{sub.nama}</h3>
          <div className="khas-sub" style={{ margin:0, fontSize:13 }}>{sub.kota}, {sub.provinsi}</div>
          <div style={{ fontSize:12, color:'var(--khas-muted-l)', marginTop:2 }}>Diajukan: {fmtDate(sub.created_at)}</div>
        </div>

        <div className="khas-riwayat-aksi">
          {isDitolak && isMine && (
            <button className="khas-btn khas-btn-primary khas-btn-sm" onClick={() => onGoTab('daftar')}>Ajukan Ulang</button>
          )}
          {isDisetujui && isMine && !penetapan && (
            <button className="khas-btn khas-btn-primary khas-btn-sm" onClick={() => onGoTab('penetapan', sub)}>Lanjut ke Penetapan</button>
          )}
          {isPtDitolak && isMine && (
            <button className="khas-btn khas-btn-outline khas-btn-sm" onClick={() => onGoTab('daftar')}>Ajukan Ulang</button>
          )}
          <button className="khas-btn khas-btn-outline khas-btn-sm" onClick={handleExpand}>
            {expanded ? 'Sembunyikan' : 'Lihat detail'}
          </button>
        </div>
      </div>

      {/* Alasan penolakan — tampil langsung tanpa expand */}
      {isDitolak && sub.catatan && (
        <div style={{
          background:'#fef2f2', border:'1px solid #fecaca',
          borderRadius:8, padding:'10px 14px', marginTop:10,
        }}>
          <div style={{ fontSize:12, fontWeight:600, color:'var(--khas-red)', marginBottom:4 }}>
            Alasan Penolakan Pengajuan:
          </div>
          <div style={{ fontSize:13, color:'var(--khas-ink)', lineHeight:1.5 }}>
            {sub.catatan}
          </div>
        </div>
      )}

      {isPtDitolak && penetapan?.alasan_tolak && (
        <div style={{
          background:'#fef2f2', border:'1px solid #fecaca',
          borderRadius:8, padding:'10px 14px', marginTop:10,
        }}>
          <div style={{ fontSize:12, fontWeight:600, color:'var(--khas-red)', marginBottom:4 }}>
            Alasan Penolakan Penetapan:
          </div>
          <div style={{ fontSize:13, color:'var(--khas-ink)', lineHeight:1.5 }}>
            {penetapan.alasan_tolak}
          </div>
        </div>
      )}

      {/* Progress bar */}
      <div style={{ marginTop:12 }}>
        <div style={{ display:'flex', justifyContent:'space-between', fontSize:12.5, color:'var(--khas-muted)', marginBottom:5 }}>
          <span>
            {isDitolak || isPtDitolak
              ? <span style={{ color:'var(--khas-red)', fontWeight:600 }}>Ditolak</span>
              : <>Tahap: <b style={{ color:'var(--khas-ink)' }}>{currentStageLabel}</b></>
            }
          </span>
          <span><b style={{ color: isDitolak||isPtDitolak ? 'var(--khas-red)' : 'var(--khas-green-d)' }}>{pct}%</b></span>
        </div>
        <div className="khas-progbar">
          <div className="khas-progbar-fill" style={{ width:pct+'%', background: isDitolak||isPtDitolak ? 'var(--khas-red)' : undefined }} />
        </div>
        <div style={{ display:'flex', justifyContent:'space-between', marginTop:5 }}>
          {STAGES.map((s, i) => (
            <div key={i} style={{
              fontSize:10, textAlign:'center', maxWidth:80,
              color: i < stagesDone ? 'var(--khas-green-d)' : i===stagesDone && stagesDone<5 ? 'var(--khas-green)' : 'var(--khas-muted-l)',
              fontWeight: i===stagesDone && stagesDone<5 ? 700 : i<stagesDone ? 600 : 400,
            }}>{s.b}</div>
          ))}
        </div>
      </div>

      {/* Detail expand */}
      {expanded && (
        <div className="khas-riwayat-expand">
          {loadingRw ? (
            <div style={{ textAlign:'center', padding:20 }}><div className="loader" /></div>
          ) : (
            <div className="khas-grid2" style={{ gap:24 }}>
              {/* Detail data */}
              <div>
                <div className="khas-lt" style={{ fontWeight:700, marginBottom:10 }}>Detail Pengajuan</div>
                <dl className="khas-kv">
                  <dt>Tipe</dt>      <dd>{sub.tipe}</dd>
                  <dt>Basis</dt>     <dd>{sub.basis||'—'}</dd>
                  <dt>Pengelola</dt> <dd>{sub.pic||'—'}</dd>
                  <dt>Instansi</dt>  <dd>{sub.instansi||'—'}</dd>
                </dl>

                {penetapan && (
                  <>
                    <div className="khas-lt" style={{ fontWeight:700, margin:'14px 0 10px' }}>Detail Penetapan</div>
                    <dl className="khas-kv">
                      <dt>Tenant</dt>           <dd>{penetapan.tenant||'—'}</dd>
                      <dt>Halal</dt>            <dd>{penetapan.halal||'—'} tenant</dd>
                      <dt>Aman &amp; Sehat</dt> <dd>{penetapan.sehat||'—'} tenant</dd>
                      <dt>Ditetapkan oleh</dt>  <dd>{penetapan.ditetapkan_oleh||'—'}</dd>
                      <dt>Rencana peresmian</dt>
                      <dd>{penetapan.rencana_peresmian
                        ? new Date(penetapan.rencana_peresmian).toLocaleDateString('id',{day:'2-digit',month:'long',year:'numeric'})
                        : '—'}</dd>
                    </dl>
                  </>
                )}
              </div>

              {/* Timeline */}
              <div>
                <div className="khas-lt" style={{ fontWeight:700, marginBottom:12 }}>Riwayat tahapan</div>
                <div className="khas-timeline">
                  {STAGES.map((st, i) => {
                    let cls = 'pending'
                    if ((isDitolak && i===1) || (isPtDitolak && i===3)) cls = 'reject'
                    else if (i < stagesDone) cls = 'done'
                    else if (i === stagesDone && stagesDone < 5) cls = 'current'
                    const entry = riwayatByStage[i]
                    return (
                      <div key={i} className={'khas-tstep '+cls}>
                        <div className="khas-tstep-dot">{cls==='done'?'✓':cls==='reject'?'✕':i+1}</div>
                        <div className="khas-tstep-line" />
                        <div className="khas-tstep-content">
                          <b>{st.b}</b>
                          <div style={{ fontSize:12.5, color:'var(--khas-muted)', marginTop:2, lineHeight:1.45 }}>{st.s}</div>
                          {entry && (
                            <div style={{ marginTop:5, display:'flex', flexDirection:'column', gap:2 }}>
                              <span style={{ fontSize:11.5, color:'var(--khas-green-d)', fontWeight:600 }}>{fmtDate(entry.created_at)}</span>
                              {entry.catatan && <span style={{ fontSize:11, color:'var(--khas-muted-l)', fontStyle:'italic' }}>{entry.catatan}</span>}
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
                {isDitolak && isMine && (
                  <div className="khas-status-msg tolak" style={{ marginTop:12 }}>
                    Pengajuan ditolak. Anda dapat mengajukan ulang.
                  </div>
                )}
                {isDisetujui && !penetapan && isMine && (
                  <div className="khas-status-msg setuju" style={{ marginTop:12 }}>
                    Pengajuan disetujui! Lanjutkan ke tab <b>Penetapan</b>.
                  </div>
                )}
                {penetapan?.status === STATUS_PENETAPAN.SELESAI && (
                  <div className="khas-status-msg setuju" style={{ marginTop:12 }}>
                    Surat Rekomendasi telah diterbitkan dan dikirimkan ke KDEKS.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

/* ── RiwayatTab ──────────────────────────────────────────── */
function RiwayatTab({ session, submissions, onGoTab }) {
  const [penetapanList, setPenetapanList] = useState([])
  const [search,        setSearch]        = useState('')

  useEffect(() => {
    penetapanApi.getAll()
      .then(data => setPenetapanList(data.penetapan || []))
      .catch(err => console.error(err))
  }, [])

  const wilayahSubs = submissions.filter(s => s.kdeks_wilayah === session.kdeks_wilayah)

  const filtered = wilayahSubs.filter(s => {
    if (!search) return true
    const q = search.toLowerCase()
    return s.nama?.toLowerCase().includes(q) ||
           s.kota?.toLowerCase().includes(q) ||
           s.id?.toLowerCase().includes(q)
  })

  const sorted = [...filtered].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))

  return (
    <div style={{ maxWidth:860, margin:'0 auto' }}>

      {/* Header + Search */}
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20, flexWrap:'nowrap' }}>
        <h2 style={{ margin:0, fontSize:18, fontWeight:700, color:'var(--khas-ink)', flexShrink:0 }}>
          Riwayat Pengajuan
        </h2>
        <div style={{ flex:1, minWidth:0 }}>
          <KhasSearchInput
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Cari nama kawasan atau kode..."
          />
        </div>
        {search && (
          <button className="khas-btn khas-btn-outline khas-btn-sm" style={{ flexShrink:0 }}
            onClick={() => setSearch('')}>
            Reset
          </button>
        )}
      </div>

      {wilayahSubs.length === 0 ? (
        <div className="khas-card">
          <div className="khas-empty">
            <div style={{ fontSize:36, marginBottom:10, opacity:.4 }}>—</div>
            <b>Belum ada pengajuan</b>
            <p style={{ margin:'8px 0 16px', fontSize:13.5, color:'var(--khas-muted)' }}>
              Belum ada pengajuan dari KDEKS {session.kdeks_wilayah}.
            </p>
            <button className="khas-btn khas-btn-primary" onClick={() => onGoTab('daftar')}>
              Ajukan Zona KHAS
            </button>
          </div>
        </div>
      ) : sorted.length === 0 ? (
        <div className="khas-card">
          <div className="khas-empty">
            <div style={{ fontSize:28, marginBottom:8, opacity:.5 }}>🔍</div>
            <b>Tidak ada hasil</b>
            <p style={{ margin:'6px 0', fontSize:13.5, color:'var(--khas-muted)' }}>Coba ubah kata kunci pencarian.</p>
          </div>
        </div>
      ) : (
        <>
          {search && (
            <p style={{ fontSize:12.5, color:'var(--khas-muted)', marginBottom:12 }}>
              Menampilkan <b>{sorted.length}</b> dari <b>{wilayahSubs.length}</b> pengajuan
            </p>
          )}
          {sorted.map(s => (
            <RiwayatCard key={s.id} sub={s} session={session} onGoTab={onGoTab} penetapanList={penetapanList} />
          ))}
        </>
      )}
    </div>
  )
}

export default RiwayatTab